import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const PlaceholderPage = ({ onBack }) => {
  const { title: urlTitle } = useParams();
  // Convert URL slug back to title (e.g., "privacy-policy" -> "Privacy Policy")
  const title = urlTitle
    ? urlTitle.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    : 'Page';

  return (
    <div className="space-y-6">
      <Button
        variant="ghost"
        onClick={onBack}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Home
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            This page is currently under construction. Please check back later.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlaceholderPage;
